/**
 * 脱式题
 */
import QuestionDelivery from './view';

export default QuestionDelivery;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/delivery/index.js